import styles from "@/components/ui/buttons/FilterBadgeComponent.module.css";

function FilterBadgeComponent({ text, onRemove }) {
  return (
    <div className={styles.cw_filter__badge} onClick={onRemove}>
      {text}
      <span className={styles.cw_filter__badge__icon}>✕</span>
    </div>
  );
}

export default FilterBadgeComponent;
